module.exports = __webpack_public_path__ + "gn.svg?8e74ea04832ff5ba94ad8330b528d8d1";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gn.svg
// module id = 1261
// module chunks = 27